<template>
  <div>
    <!-- Page Header Start -->

    <div
      v-show="props.aboutHeaderVisible"
      class="container-fluid page-header py-5 mb-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div class="container text-center py-5">
        <h1 class="display-3 text-white mb-4 animated slideInDown">Über uns</h1>
        <!-- <nav aria-label="breadcrumb animated slideInDown">
          <ol class="breadcrumb justify-content-center mb-0">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">Pages</a></li>
            <li class="breadcrumb-item active" aria-current="page">About</li>
          </ol>
        </nav> -->
      </div>
    </div>
    <!-- Page Header End -->

    <!-- About Start -->
    <div class="container-xxl py-5">
      <div class="container">
        <div class="row g-5 align-items-end">
          <div class="col-lg-3 col-md-5 wow fadeInUp" data-wow-delay="0.1s">
            <img
              class="img-fluid rounded"
              data-wow-delay="0.1s"
              src="img/gazi1.jpg"
              :alt="globalConfig.altPictureText"
            />
          </div>
          <div class="col-lg-9 col-md-7 wow fadeInUp" data-wow-delay="0.8s">
            <h1 class="display-1 text-primary mb-0">20+</h1>
            <p class="text-primary mb-4">Jahre Erfahrung</p>
            <h1 class="display-5 mb-4">
              Ihr Zuhause verdient einen Traumgarten - wir machen es möglich
            </h1>

            <ul>
              <li class="mb-1">
                <b>Gartengestaltung und -pflege</b> – Individuelle Gestaltung
                und fachgerechte Pflege Von Wege Ihren Traumgarten.
              </li>
              <li class="mb-1">
                <b>Entsorgung Gartenabfälle</b> – Saubere und zuverlässige
                Entsorgung von Grün- und Gartenabfällen.
              </li>
              <li class="mb-1">
                <b>Zäune und Einfriedungen</b> – Stabile und ästhetische
                Lösungen für Sicherheit und Privatsphäre.
              </li>
              <li class="mb-1">
                <b>Pflastersteine und Platten verlegen</b> – Fachmännisches
                Verlegen Von Wege, Einfahrten und Terrassen.
              </li>
              <li class="mb-1">
                <b>Holzterrassen</b> – Natürliche und langlebige Terrassen aus
                hochwertigem Holz.
              </li>
              <li class="mb-1">
                <b>Baumfällung</b> – Sichere und professionelle Baumfällarbeiten
                jeder Größe.
              </li>
              <li class="mb-1">
                <b>Baum- und Heckenschneiden</b> – Präziser Schnitt für gesunde
                Bäume und gepflegte Hecken.
              </li>
            </ul>

            <!-- <a class="btn btn-primary py-3 px-4" href="">Explore More</a> -->
          </div>
          <!-- <div class="col-lg-3 col-md-12 wow fadeInUp" data-wow-delay="0.5s">
            <div class="row g-5">
              <div class="col-12 col-sm-6 col-lg-12">
                <div class="border-start ps-4">
                  <i class="fa fa-award fa-3x text-primary mb-3"></i>
                  <h4 class="mb-3">Award Winning</h4>
                  <span
                    >Clita erat ipsum et lorem et sit, sed stet lorem sit clita
                    duo justo magna</span
                  >
                </div>
              </div>
              <div class="col-12 col-sm-6 col-lg-12">
                <div class="border-start ps-4">
                  <i class="fa fa-users fa-3x text-primary mb-3"></i>
                  <h4 class="mb-3">Dedicated Team</h4>
                  <span
                    >Clita erat ipsum et lorem et sit, sed stet lorem sit clita
                    duo justo magna</span
                  >
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- About End -->

    <Facts></Facts>
  </div>
</template>

<script setup>
import Facts from './Facts.vue';
import { defineProps } from 'vue';
import config from '../../store/global.js';
const globalConfig = config.global().globalConfig;

const props = defineProps({
  aboutHeaderVisible: { type: Boolean, default: true },
});

// onMounted(() => {
//   props.aboutHeaderVisible = true;
// });
</script>
